import type { ElementType, FC, HTMLAttributes } from 'react';
import cn from '@/ui/utils/cn/cn';

import $ from './Typography.module.scss';

export type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'bodyLarge'
  | 'bodyMedium'
  | 'bodySmall'
  | 'preTitle'
  | 'button';

export type TypographyWeight = 'thin' | 'light' | 'regular' | 'medium' | 'bold';

type TypographyProps = HTMLAttributes<HTMLElement> & {
  variant?: TypographyVariant;
  element?: ElementType;
  center?: boolean;
  weight?: TypographyWeight;
};

const Typography: FC<TypographyProps> = ({
  variant = 'bodyMedium',
  element,
  children,
  center,
  className,
  weight,
  ...restProps
}) => {
  const variantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    bodyLarge: 'p',
    bodyMedium: 'p',
    bodySmall: 'p',
    preTitle: 'h4',
    button: 'span',
  } as const;

  const Element = element || variantMapping[variant];

  return (
    <Element
      className={cn(
        $[variant],
        center && $.center,
        $.noMargin,
        weight && $[weight],
        className,
      )}
      {...restProps}
    >
      {children}
    </Element>
  );
};

export default Typography;
